import React from "react";
import { AppProvider, Frame, Image, Layout, Page } from "@shopify/polaris";
import FortifyLogo from "images/tenants/default/logo.svg";

const LoadingScreen = () => {
  return (
    <AppProvider>
      <Frame>
        <Page>
          <Layout>
            <Layout.Section>
            <div
                style={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                  <Image source={FortifyLogo} />
              </div>
            </Layout.Section>
          </Layout>
        </Page>
      </Frame>
    </AppProvider>
  );
};

export default LoadingScreen;
